module.exports = __webpack_public_path__ + "img/dialog.b5503163.png";